import * as api from '../../services/barrage'
import lodash from 'lodash'
export const FETCH_BARRAGECONFIGS= 'FETCH_BARRAGECONFIGS';
export const FETCH_BARRAGEMESSAGE= 'FETCH_BARRAGEMESSAGE';




export const fetchBarrageConfigs = (params, pagination, sort, extra) => {

    return {
        type: FETCH_BARRAGECONFIGS,
        payload: {
            promise: api.findBarrageConfigs(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};

export const fetchBarrageMessage = (params, pagination, sort, extra) => {

    return {
        type: FETCH_BARRAGEMESSAGE,
        payload: {
            promise: api.findBarrageMessage(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams:lodash.omit(params, 'configId'),
            sort: sort,
            extra: extra
        }
    };
};


// WEBPACK FOOTER //
// ./src/redux/actions/barrage.js